export default __webpack_public_path__ + "static/media/PortfolioWebsite.2138f5e9.jpg";